var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "instagramInterface", staticClass: "instagram-interface" },
    [
      _c("div", { staticClass: "page-name" }, [
        _c("p", [_vm._v(_vm._s(_vm.page ? _vm.page.name : "Instagram"))])
      ]),
      _c("div", { staticClass: "user-info" }, [
        _c("div", { staticClass: "picture" }, [
          _c("img", {
            attrs: {
              src:
                _vm.page && _vm.page.avatar ? _vm.page.avatar : "img/avatar.jpg"
            }
          })
        ]),
        _c("div", { staticClass: "stats" }, [
          _c("div", { staticClass: "stat" }, [
            _c("p", [_vm._v(_vm._s(_vm.statsProfile.media_count))]),
            _c("label", [_vm._v("Publications")])
          ]),
          _c("div", { staticClass: "stat" }, [
            _c("p", [_vm._v(_vm._s(_vm.statsProfile.followers_count))]),
            _c("label", [_vm._v("Followers")])
          ]),
          _c("div", { staticClass: "stat" }, [
            _c("p", [_vm._v(_vm._s(_vm.statsProfile.follows_count))]),
            _c("label", [_vm._v("Suivi(e)s")])
          ])
        ])
      ]),
      _c("div", { staticClass: "nav" }, [
        _c("div", { staticClass: "item" }, [
          _c(
            "svg",
            {
              attrs: {
                fill: "currentColor",
                height: "100%",
                width: "100%",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c("rect", {
                attrs: {
                  fill: "none",
                  height: "18",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  width: "18",
                  x: "3",
                  y: "3"
                }
              }),
              _c("line", {
                attrs: {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  x1: "9.015",
                  x2: "9.015",
                  y1: "3",
                  y2: "21"
                }
              }),
              _c("line", {
                attrs: {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  x1: "14.985",
                  x2: "14.985",
                  y1: "3",
                  y2: "21"
                }
              }),
              _c("line", {
                attrs: {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  x1: "21",
                  x2: "3",
                  y1: "9.015",
                  y2: "9.015"
                }
              }),
              _c("line", {
                attrs: {
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  x1: "21",
                  x2: "3",
                  y1: "14.985",
                  y2: "14.985"
                }
              })
            ]
          )
        ])
      ]),
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "container-grid hide-scrollbar",
          on: { scroll: _vm.handleScroll }
        },
        [
          _c(
            "draggable",
            _vm._b(
              {
                ref: "listMedia",
                staticClass: "list-photo hide-scrollbar",
                attrs: { move: _vm.checkMove, filter: ".posted" },
                on: {
                  start: function($event) {
                    _vm.drag = true
                  },
                  end: function($event) {
                    _vm.drag = false
                  },
                  update: _vm.updateList
                },
                model: {
                  value: _vm.list,
                  callback: function($$v) {
                    _vm.list = $$v
                  },
                  expression: "list"
                }
              },
              "draggable",
              _vm.dragOptions,
              false
            ),
            [
              _c(
                "transition-group",
                { attrs: { type: "transition", name: "flip-list" } },
                [
                  _vm._l(_vm.list, function(post) {
                    return _c(
                      "div",
                      {
                        key: post.id,
                        staticClass: "photo",
                        class: [post.status, post.type],
                        style: { backgroundImage: "url(" + post.url + ")" },
                        attrs: { id: post.id }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "circle-status card-status-background-primary-color",
                          class: [post.status]
                        })
                      ]
                    )
                  }),
                  _vm._l(
                    Array.from({ length: (this.list.length % 3) + 6 }),
                    function(test, index) {
                      return _vm.loadingCard
                        ? _c("div", {
                            key: index,
                            staticClass: "photo loading",
                            style: "animation-delay: " + index * 0.2 + "s"
                          })
                        : _vm._e()
                    }
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }